export default "__VITE_ASSET__CGRypTzl__"